import { render } from "./AuditHistory.vue?vue&type=template&id=15194dc5&scoped=true"
import script from "./AuditHistory.vue?vue&type=script&lang=js"
export * from "./AuditHistory.vue?vue&type=script&lang=js"

import "./AuditHistory.vue?vue&type=style&index=0&id=15194dc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15194dc5"]])

export default __exports__